import React from "react";
import { Alert } from "@mui/material";
import { useAdminDataGuard } from "../hooks/useAdminDataGuard";
import LogPanel from "../components/auditLogs/LogPanel";

const AuditLogPage = () => {
  const canAccessAdminData = useAdminDataGuard();

  if (!canAccessAdminData) {
    return <Alert severity='error'>Admin token validation failed.</Alert>;
  }

  return <LogPanel />;
};

export default AuditLogPage;
